export { Profiles } from "./Profiles";
export { ProfileSettings } from "./Settings";
import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Profiles } from "./Profiles";
import { ProfileSettings } from "./Settings";

const ShowsOnlyFirst = styled.div`
  & > * + * {
    display: none !important;
  }
`;

const getRules = (response) => {
  const lines = response.trim().split("\n");
  const rules = lines.reduce((acc, line) => {
    if (line.startsWith(`rule`)) {
      acc.push(line);
    }
    return acc;
  }, []);
  return rules;
}

const ProfilesAndSettings = ({ ...settings }) => {
  const [rules, setRules] = useState("");

  useEffect(() => {
    ifCl
      .run("show config running all")
      .then((response) => {
        const rules = getRules(response);
        setRules(rules)}
      )
      .catch((error) => console.log(error));
  }, []);

  return (
    <ShowsOnlyFirst>
      {<ProfileSettings {...settings} />}
      {/*or will show*/}
      <Profiles {...settings} rules={rules} />
    </ShowsOnlyFirst>
  );
};

export default ProfilesAndSettings;
